import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export default function AdminNavbar() {
    const location = useLocation();
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        navigate('/admin-login');
    };

    const activeStyle = {
        background: 'rgba(255, 255, 255, 0.15)',
        color: '#ffffff',
        padding: '8px 16px',
        borderRadius: '20px',
        textDecoration: 'none',
        fontWeight: '600',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
    };
    
    const inactiveStyle = {
        color: '#94a3b8',
        padding: '8px 16px',
        borderRadius: '20px',
        textDecoration: 'none',
        fontWeight: '500',
        transition: 'all 0.2s ease'
    };

    return (
        <div className="admin-navbar mb-4" style={{
            background: 'linear-gradient(135deg, #0f172a, #1e293b)', 
            padding: '20px 30px', 
            borderRadius: '24px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 15px 35px rgba(0,0,0,0.15), 0 5px 15px rgba(0,0,0,0.05)'
        }}>
            <div className="d-flex align-items-center" style={{flexWrap: 'wrap'}}>
                <h3 className="text-white m-0 mr-4 pr-4" style={{borderRight: '1px solid rgba(255,255,255,0.2)', fontWeight: '800', letterSpacing: '-0.5px'}}>
                    <span style={{color: '#60a5fa'}}>⚙️</span> Dashboard
                </h3>
                <nav className="d-flex align-items-center" style={{gap: '12px', flexWrap: 'wrap'}}>
                    <Link 
                        to="/admin/inbox" 
                        className="admin-nav-link"
                        style={location.pathname.includes('/inbox') ? activeStyle : inactiveStyle}
                    >
                        📥 Inbox
                    </Link>
                    <Link 
                        to="/admin/news" 
                        className="admin-nav-link"
                        style={location.pathname.includes('/news') ? activeStyle : inactiveStyle}
                    >
                        📰 News
                    </Link>
                    <Link 
                        to="/admin/gallery" 
                        className="admin-nav-link"
                        style={location.pathname.includes('/gallery') ? activeStyle : inactiveStyle}
                    >
                        🖼️ Gallery
                    </Link>
                    <Link 
                        to="/admin/staff" 
                        className="admin-nav-link"
                        style={location.pathname.includes('/staff') ? activeStyle : inactiveStyle}
                    >
                        👥 Staff
                    </Link>
                    <Link 
                        to="/admin/classes" 
                        className="admin-nav-link"
                        style={location.pathname.includes('/classes') ? activeStyle : inactiveStyle}
                    >
                        🎓 Classes
                    </Link>
                    <Link 
                        to="/admin/facilities" 
                        className="admin-nav-link"
                        style={location.pathname.includes('/facilities') ? activeStyle : inactiveStyle}
                    >
                        🏰 Facilities
                    </Link>
                    <Link 
                        to="/admin/testimonials" 
                        className="admin-nav-link"
                        style={location.pathname.includes('/testimonials') ? activeStyle : inactiveStyle}
                    >
                        💬 Testimonials
                    </Link>
                    <Link 
                        to="/admin/faq" 
                        className="admin-nav-link"
                        style={location.pathname.includes('/faq') ? activeStyle : inactiveStyle}
                    >
                        ❓ FAQ
                    </Link>
                    <Link 
                        to="/admin/settings" 
                        className="admin-nav-link"
                        style={location.pathname.includes('/settings') ? activeStyle : inactiveStyle}
                    >
                        ⚙️ Settings
                    </Link>
                </nav>
            </div>
            <button className="btn btn-sm btn-danger font-weight-bold" style={{borderRadius: '12px', padding: '8px 20px', boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)'}} onClick={handleLogout}>Logout</button>
        </div>
    );
}
